import React from 'react';
import FormWizardContainer from '../../../Componant/Forms/FormLayout/FormWizard1';

const FormWizardOne = () => {
  return (
    <div className='page-body'>
      <FormWizardContainer />
    </div>
  );
};

export default FormWizardOne;
